import { createSlice } from "@reduxjs/toolkit";
import axios from "../utils/axios";

interface MemberApiErrorMessage {
    status:boolean,
    message:string
}
interface FetchMember {
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    countryCode?: any,
    countryShortName?: any,
    id?: number
}

export interface MemberState {
members:{
        isloading: boolean,
        status:boolean,
        message: string,
        data:{
            count:string,
            rows:FetchMember[]
        }
    }
    GetAddEditMember: {
        status:boolean,
        message:string,
        data: FetchMember,
        error: boolean
    },
    createMember: {
        isloading: boolean,
        status: boolean,
        message: string,
        data: {
            count: string,
            rows: FetchMember
        }
    },
    Addmemberinfo: {
        title: string,
        action: string,
        data: FetchMember,
        id: string
    };
    editMemberButton: {
        title: string,
        action: string,
        data: FetchMember,
        id: string
    };
    paginationMember: {
        max: string | number,
        limit: any,
        currentPage: any,
        data:{
                count:string,
                rows:Array<FetchMember>
        }
    },
    AlertMessageState: {
        show: boolean;
        type: string;
        message: string;
        showModal: boolean;
    },
    ErrorMessageMember: {
        data: MemberApiErrorMessage,
        error: boolean,
    },
    ErrorUpdateMember: MemberApiErrorMessage,
    username: string,
    
}
const initialState: MemberState = {

    members: {
        isloading: false,
        status:false,
        message:'',
        data:{
            count:'',
            rows:[],
        },
    },
    GetAddEditMember: {
        status:false,
        message:'',
        data: null,
        error: false
    },

    AlertMessageState: null,
    createMember: {
        isloading: false,
        status: false,
        message: '',
        data: {
            count: '',
            rows: null
        },
    },
    Addmemberinfo: {
        title: '',
        action: '',
        data: null,
        id: ''
    },
    editMemberButton: {
        title: '',
        action: '',
        data: null,
        id: ''
    },
    paginationMember: {
        max: 1,
        limit: 10,
        currentPage: 0,
        data: {
            count: '',
            rows: [],
        },
    },
    ErrorMessageMember: {
        data: null,
        error: false
    },
    ErrorUpdateMember: null,
    username: ""
}
const Slice = createSlice({
    name: 'member',
    initialState,
    reducers: {
        addMember: (state, action) => {
            state.members = action.payload
        },
        membersReceived: (state, action) => {
            state.members = action.payload;
            state.members = {
                ...state.members,
                isloading: false
            }
        },
        membersDataLoading: (state) => {
            state.members.isloading = true;
        },
        memberDeleted: (state, action) => {
            state.members.isloading = true;
        },
        membersRequestFailed: (state, action) => {
            state.members = action.payload;
        },

        GetAddEditMember(state, action) {
            state.GetAddEditMember = action.payload;
          },

        GetAddEditMemberError(state, action) {
            state.GetAddEditMember = {
                ...state.GetAddEditMember,
                status: false,
                data: action.payload,
                error: true,
            };
        },
        showAlertMessage(state, action) {
            state.AlertMessageState = {
                show: true,
                type: action.payload.type,
                message: action.payload.message,
                showModal: action.payload.showModal,
            };
        },

        createMemberInfo: (state, action) => {
            state.createMember = action.payload;
        },
        createMemberErrorInfo: (state, action) => {
            state.createMember = {
                ...state.createMember,
                isloading: false,
                status: false
            };
        },
        clearMemberAlertMessage(state) {
            state.AlertMessageState = {
                show: false,
                type: null,
                message: null,
                showModal: false,
            };
        },
        
        clearMemberData(state) {
            state.GetAddEditMember.data = null;
            state.createMember = {
                isloading: false,
                status: false,
                message: '',
                data: {
                    count: '',
                    rows: null
                }
            };
            state.AlertMessageState = null
        },
        AddMemberInfoData(state, action) {
            state.Addmemberinfo = action.payload;
        },
        setMemberCurrentPage(state, action) {
            state.paginationMember.currentPage = action.payload;
        },
        paginationItemMember(state, action) {
            state.paginationMember = action.payload;
            state.paginationMember.limit = 10
        },
        searchItem(state,action){
            state.members= action.payload;
        },
        ErrorMessageMember(state,action){
            state.ErrorMessageMember={
                data:action.payload,
                error:true
            }

        },
        ErrorUpdateMember(state,action){
            state.ErrorUpdateMember = action.payload
        },
        updateMemberName(state, action) {
            state.username = action.payload
        }
    }
})

// Fetch Limit Members
export const FetchMemberData = (data:any) => async (dispatch: any) => {
    dispatch(Slice.actions.membersDataLoading())
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/procurementteam?page=${data}`)
        dispatch(Slice.actions.membersReceived(res.data))
        

    } catch (err) {
        dispatch(Slice.actions.membersRequestFailed(err))
        dispatch(Slice.actions.ErrorMessageMember(err));
    }
}

// Fetch All Members for pagination
export const FetchAllMember = () => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/procurementteam?size=all`)
        dispatch(Slice.actions.paginationItemMember(res.data))

    } catch (err) {
        dispatch(Slice.actions.membersRequestFailed(err))
        dispatch(Slice.actions.ErrorMessageMember(err));
    }
}

// Create Members
export const CreateMemberData = (DatQ: any) => async (dispatch: any) => {
    try {
        const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/procurementTeam`, DatQ);
        dispatch(Slice.actions.createMemberInfo(res.data))
        dispatch(Slice.actions.showAlertMessage({
            message: 'New Member Added',
            type: "success"
        }));
    } catch (error) {
        
        dispatch(Slice.actions.showAlertMessage({
            message: error.message,
            type: "error"
        }));
        dispatch(Slice.actions.createMemberErrorInfo(error));
    }
}



// Update Members
export const updateMember = (DatQ1: any, DatQ2: any, isSame: boolean) => async (dispatch: any) => {
    try {
        const res = await axios.put(`${process.env.REACT_APP_BASE_URL}/procurementteam/${DatQ1}`, DatQ2);
        dispatch(Slice.actions.createMemberInfo(res.data));
        dispatch(FetchMemberData(0));
        if (isSame) {
            dispatch(Slice.actions.updateMemberName(`${DatQ2.firstName} ${DatQ2.lastName}`))
        }
        dispatch(Slice.actions.showAlertMessage({
            message: "Member Details Updated",
            type: "success"
        }));
    } catch (err) { 
        dispatch(Slice.actions.showAlertMessage({
            message: err.message,
            type: "error"
        }));
        dispatch(Slice.actions.createMemberErrorInfo(err));
        
    }
}



// Delete Members
export const deleteMember = (DatQ1: any) => async (dispatch: any) => {
    try {
        await axios.delete(`${process.env.REACT_APP_BASE_URL}/procurementteam/${DatQ1}`).then((res) =>
            dispatch(Slice.actions.memberDeleted(res.data)));
            dispatch(FetchMemberData(0));
            dispatch(Slice.actions.showAlertMessage({
                message: 'Member Removed',
                type: "success"
            }));

    } catch (err) {
        dispatch(Slice.actions.membersRequestFailed(err))
    }
}
// to edit member detail
export const GetMemberEditInfo = (id: any) => async (dispatch: any) => {

    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/procurementteam/${id}`);
        dispatch(Slice.actions.GetAddEditMember(res.data));
    } catch (err) {
        dispatch(Slice.actions.GetAddEditMemberError(err))
    }
};
export const clearMemberDatainfo = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearMemberData());
};

export const GetMemberInfoData = (data) => async (dispatch: any) => {
    dispatch(Slice.actions.AddMemberInfoData(data));
};
// pagination
export const setMemberCurrentPage = (data: any) => async (dispatch: any) => {
    dispatch(Slice.actions.setMemberCurrentPage(data));
};
// get Users
export const GetEditInfoMember = (DatQ1: any) => async (dispatch: any) => {
    try {
        const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/procurementteam?id=${DatQ1}`)
        dispatch(Slice.actions.GetAddEditMember(res.data));
    } catch (err) {
        dispatch(Slice.actions.membersRequestFailed(err))
    }
}
// clear data
export const clearMemberAlertMessage = () => async (dispatch: any) => {
    dispatch(Slice.actions.clearMemberAlertMessage());
};

export const { GetAddEditMember,ErrorUpdateMember,showAlertMessage } = Slice.actions;
export const reducer = Slice.reducer;
export default Slice;